export default __webpack_public_path__ + "static/media/secure.e47dcb14.png";